import React from "react";
import Search from "../../../atoms/Filters/Search";
import DropdownFilter from "../../../atoms/Filters/DropdownFilter";
import TwoOptionFilter from "../../../atoms/Filters/TwoOptionFilter";
import DateInputFilter from "components/MainApp/atoms/Filters/DateInputFilter"

import styles from "./MainApp.organisms.Filters.FilterPanel.module.scss";
import { isMobile } from "helpers/Mobile";
import i18n from "i18n";

const inputTypes = {
  'dropdown': DropdownFilter,
  'twoOption': TwoOptionFilter,
  'dateRange': DateInputFilter,
}

export class FilterPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      edit: false,
      buttonEnabled: false,
      filters: this.props.filters,
      selectedFiltersAll: this.props.selectedFiltersAll,
      selectedFiltersByType: this.props.selectedFiltersByType,
      appliedFilters: {
        filters: this.props.filters,
        selectedFiltersAll: this.props.selectedFiltersAll,
        selectedFiltersByType: this.props.selectedFiltersByType,
      },
    };
  }

  componentDidUpdate(prevProps) {
    /**
     * Deep compare filter props to trigger state updates only when data actually changes.
     * Using JSON.stringify as a simple way to detect nested object changes.
     */
    const filtersChanged = JSON.stringify(prevProps.filters) !== JSON.stringify(this.props.filters);
    const selectionsChanged = JSON.stringify(prevProps.selectedFiltersByType) !== JSON.stringify(this.props.selectedFiltersByType);

    if (filtersChanged || selectionsChanged) {
      this.setState({
        filters: this.props.filters,
        selectedFiltersByType: this.props.selectedFiltersByType,
        selectedFiltersAll: this.props.selectedFiltersAll
        // buttonEnabled is not reset here to avoid unnecessary re-renders
      });
    }
  }

  handleOpenPanel = () => {
    const open = !this.state.open;
    this.setState({
      open,
    });
  };

  handleSelection = (option, operation, type) => {
    if (operation === "deleteAll") {
      this.deleteAll(type);
      return;
    }

    let selectedFiltersAll = [...this.state.selectedFiltersAll];
    let selectedFiltersByType = { ...this.state.selectedFiltersByType };



    if (operation === "add") {
      option.type = type;
      selectedFiltersAll = [...selectedFiltersAll, option];
      selectedFiltersByType[type] = selectedFiltersByType[type]
        ? [...selectedFiltersByType[type], option]
        : [option];
    } else {
      if(operation === "replace") {
        option.type = type;

        selectedFiltersAll = selectedFiltersAll.filter(s => s.type !== option.type)
        selectedFiltersAll = [...selectedFiltersAll, option];
        selectedFiltersByType[type] = [option];

      }
      else{
        selectedFiltersAll = this.state.selectedFiltersAll.filter((s) => {
          return s.label !== option.label;
        });

        selectedFiltersByType[type] = this.state.selectedFiltersByType[
          type
        ].filter((s) => {
          return s.label !== option.label;
        });
      }

    }

    this.setState({
      selectedFiltersAll,
      selectedFiltersByType,
      buttonEnabled: true,
    });
  };

  handleApply = () => {
    if (!this.state.buttonEnabled) return;
    this.setState({
      open: false,
      buttonEnabled: false,
    });
    //handler externo

    this.props.handleApplyFilters(
      this.state.selectedFiltersByType,
      this.state.selectedFiltersAll
    );
  };

  deleteAll = (type = null) => {
    if (type) {
      this.deleteFromType(type);
      return;
    }
    let filters = [...this.state.filters];
    filters = filters.map((f) => {
      if (f?.options){
        f.options = f.options.map((o) => {
          o.selected = false;
          return o;
        });
      }

      return f;
    });

    this.setState({
      filters: filters,
      selectedFiltersAll: [],
      selectedFiltersByType: [],
      buttonEnabled: true,
    });
  };

  deleteFromType = (type) => {
    let filters = this.state.filters ? [...this.state.filters] : [];
    if (filters.length > 0) {
      filters = filters.map((f) => {
        if (f.options && f.options.length > 0) {
          f.options = f.options.map((o) => {
            if (f.label === type) {
              o.selected = false;
            }
            return o;
          });
        }
        return f;
      });
    }

    let selectedFiltersAll = this.state.selectedFiltersAll ? [...this.state.selectedFiltersAll] : [];
    selectedFiltersAll = selectedFiltersAll.filter((o) => {
      return o.type !== type;
    });

    let selectedFiltersByType = this.state.selectedFiltersByType ? { ...this.state.selectedFiltersByType } : {};
    delete selectedFiltersByType[type];

    this.setState({
      filters: filters,
      selectedFiltersAll: selectedFiltersAll,
      selectedFiltersByType: selectedFiltersByType,
      buttonEnabled: true,
    });
  };

  handleDelete = () => {
    this.deleteAll();

    this.setState({
      open: false,
      buttonEnabled: false,
    });

    this.props.handleApplyFilters([], []);
  };

  handleDeletePill = (option) => {
    // let selectedItem = e.target.dataset.option;

    let type = option.type;
    let selectedFiltersByType = {
      ...this.state.selectedFiltersByType,
    };
    selectedFiltersByType[type] = selectedFiltersByType[type].filter((f) => {
      return f.label !== option.label;
    });

    let selectedFiltersAll = [...this.state.selectedFiltersAll];
    selectedFiltersAll = selectedFiltersAll.filter((f) => {
      return f.label !== option.label;
    });

    this.setState({
      open: false,
      buttonEnabled: false,
      filters: this.state.filters,
      selectedFiltersAll: selectedFiltersAll,
      selectedFiltersByType: selectedFiltersByType,
    });

    this.props.handleApplyFilters(selectedFiltersByType, selectedFiltersAll);
  };

  handleDeletePillMobile = (option) => {
    // let selectedItem = e.target.dataset.option;

    let type = option.type;
    let selectedFiltersByType = {
      ...this.state.selectedFiltersByType,
    };

    if(type === 'date'){
      selectedFiltersByType[type].filter((f) => {
        return f.label !== option.label;
      });
    }
    selectedFiltersByType[type] = selectedFiltersByType[type].filter((f) => {
      return f.label !== option.label;
    });

    let selectedFiltersAll = [...this.state.selectedFiltersAll];
    selectedFiltersAll = selectedFiltersAll.filter((f) => {
      return f.label !== option.label;
    });

    this.setState({
      open: false,
      filters: this.state.filters,
      selectedFiltersAll: selectedFiltersAll,
      selectedFiltersByType: selectedFiltersByType,
    });

    this.props.handleApplyFilters(selectedFiltersByType, selectedFiltersAll);

  };

  render() {
    const {
      resultList,
      placeholder,
      searchValue = "",
      handleSubmitSearch,
      handleSubmitSearchKey,
      // filters,
      closeMobilePanel,
      filterProducts,
    } = this.props;
    return (
      <div className={styles["filter-panel-container"]}>
        <div className={styles["filter-panel-wrapper"]} data-automation-id="filter-panel">
          {!isMobile && (
            <React.Fragment>
              <Search
                resultList={resultList}
                placeholder={placeholder}
                value={searchValue}
                handleSubmit={handleSubmitSearch}
                handleSubmitKey={handleSubmitSearchKey}
                filterProducts={filterProducts}
              ></Search>
              <button
                className={styles["filter-panels-button"]}
                data-automation-id="open-filters"
                onClick={this.handleOpenPanel}
              >
                <i
                   className={`${styles["filter-panel-icon"]} ${this.state.open ? "icon-iconos_menos " + styles["icon-iconos_menos"] : "icon-iconos_mas"}`}

                ></i>
                {i18n.t("filters")}
              </button>
            </React.Fragment>
          )}

          {isMobile && (
            <div className={styles["filter-panel-mobile-title"]}>
              <p className={styles["filter-panel-mobile-title-text"]}>
                {i18n.t("filter.your.search")}
              </p>
              <i
                className={`icon-iconos_close2 ${styles["filter-panel-mobile-close"]}`}
                onClick={closeMobilePanel}
              ></i>
            </div>
          )}
        </div>
        {!this.state.open &&
          !isMobile &&
          this.props.selectedFiltersAll?.length > 0 && (
            <React.Fragment>
              {isMobile && (
                <p className={styles["filter-panels-pills-title"]}>{i18n.t("filters.applied")}</p>
              )}

              <div className={styles["filter-panels-pills"]}>
                {this.props.selectedFiltersAll.map((s) => {
                  return (
                    <div
                      className={styles["filter-panels-pill"]}
                      onClick={() => this.handleDeletePill(s)}
                      key={s.label}
                    >
                      <span>{s.label}</span>
                      <i className="icon-iconos_close2"></i>
                    </div>
                  );
                })}
                {!isMobile && (
                  <div
                    className={styles["filter-panel-pills-delete-all"]}
                    onClick={this.handleDelete}
                  >
                    {i18n.t("delete.all").toUpperCase()}
                  </div>
                )}
              </div>
            </React.Fragment>
          )}

        {!this.state.open &&
          isMobile &&
          this.state.selectedFiltersAll?.length > 0 && (
            <React.Fragment>
              {isMobile && (
                <p className={styles["filter-panels-pills-title"]}>{i18n.t("filters.applied")}</p>
              )}

              <div className={styles["filter-panels-pills"]}>
                {this.state.selectedFiltersAll.map((s) => {
                  return (
                    <div
                      className={styles["filter-panels-pill"]}
                      onClick={() => this.handleDeletePillMobile(s)}
                      key={s.label}
                    >
                      <span>{s.label}</span>
                      <i className="icon-iconos_close2"></i>
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          )}

        {(this.state.open || isMobile) && (
          <div className={styles["filter-panel-opened"]}>
            <div className={styles["filter-panel-filter-wrapper"]}>
              {/* Iterate through available filters, ensuring they are enabled 
                and mapping them to their corresponding UI components.
              */}
              {(this.props.filters || [])
                 // Render filter if f.enabled is either true or undefined (defaults to visible)
                .filter((f) => f && f.enabled !== false)
                .map((filter) => {
                  // Resolve the component type dynamically based on the filter configuration
                  let FilterComponent = inputTypes[filter.type];
                  // Guard clause: skip rendering if the filter type is not supported or defined
                  if (!FilterComponent) return null;
                  return (
                    <div className={styles["filter-panel-filter"]} key={filter.name || filter.label}>
                      <FilterComponent
                        label={filter.label}
                        options={filter.options}
                        selectedOptions={
                          this.state.selectedFiltersByType[filter.name]
                        }
                        firstOptionLabel={filter.firstOptionLabel}
                        handleSelection={(option, op) => this.handleSelection(option, op, filter.name)}
                        name={filter.name}
                      ></FilterComponent>
                    </div>
                  );
                })}
            </div>

            <div className={styles["filter-panel-filter-buttons"]}>
              <button
                className={`${styles["filter-panel-filter-apply"]} ${
                  this.state.buttonEnabled ? "" : styles["disabled"]
                }`}
                onClick={this.handleApply}
              >
                {i18n.t("apply").toUpperCase()}
              </button>
              <button
                className={styles["filter-panel-filter-delete"]}
                onClick={this.handleDelete}
              >
                {i18n.t("delete").toUpperCase()}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FilterPanel;
